import CloseIcon from "@mui/icons-material/Close";
import HubIcon from "@mui/icons-material/Hub";
import MapIcon from "@mui/icons-material/Map";
import CallIcon from "@mui/icons-material/Call";
import SendIcon from "@mui/icons-material/Send";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Contact = () => {
  const navigate = useNavigate();
  const form = useRef();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
    subject: "",
  });

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_lu4neth",
        "template_gykt5vf",
        form.current,
        "_DgWr54CLRLYZLuXi"
      )
      .then(
        (result) => {
          toast.success("Message Sent Successfully");
        },
        (error) => {
          toast.error("Failed to send message");
        }
      );
  };

  function changeHandler(event) {
    const { name, value, checked, type } = event.target;
    setFormData((prev) => {
      return { ...prev, [name]: type === "checkbox" ? checked : value };
    });
  }

  return (
    <div className="bg-[#111] text-white min-h-screen">
      <div className="absolute right-14 top-7 max-md:right-6 max-md:top-4">
        <button
          onClick={() => navigate("/")}
          className="after:border-2 after:border-[#009e66] after:w-4/5 after:h-4/5 after:animate-ping after:ease-out after:absolute after:rounded-full after:right-1 after:top-1"
        >
          <CloseIcon sx={{ fontSize: "38px", color: "#009e66" }} />
        </button>
      </div>
      <p className="text-thin pt-16 text-[#9f9f9f]  text-center">
        Feel free to contact me anytimes
      </p>
      <h1 className=" lg:text-4xl font-bold text-xl md:text-2xl  text-center ">
        Contact Me
      </h1>

      <div className="md:w-3/4 w-11/12 bg-[#000000]  shadow-2xl mx-auto py-6 px-6  mt-8 flex flex-col-reverse md:flex-row gap-4 ">
        <div className=" rounded-2xl shadow-2xl">
          <div className="flex">
            <h1 className="font-bold text-2xl">Send us a message</h1>
          </div>
          <form ref={form} onSubmit={sendEmail}>
            <div className="grid gap-3 md:grid-cols-2 mt-5">
              <input
                className="w-full bg-[#161616] text-[#777] mt-2 p-3 focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={changeHandler}
                autoComplete="off"
                required
              />
              <input
                className="w-full bg-[#161616] text-[#777] mt-2 p-3 focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={changeHandler}
                autoComplete="off"
                required
              />
              <input
                className="w-full bg-[#161616] text-[#777] mt-2 p-3 focus:outline-none focus:shadow-outline"
                type="email"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={changeHandler}
                autoComplete="off"
                required
              />
              <input
                className="w-full bg-[#161616] text-[#777] mt-2 p-3 focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="Subject"
                value={formData.subject}
                onChange={changeHandler}
                name="subject"
                autoComplete="off"
                required
              />
            </div>
            <div className="my-4">
              <textarea
                placeholder="Message"
                name="message"
                value={formData.message}
                onChange={changeHandler}
                className="w-full h-32 bg-[#161616] text-[#777] mt-2 p-3 focus:outline-none focus:shadow-outline"
                autoComplete="off"
                required
              />
            </div>
            <div className="my-2 w-1/2 lg:w-1/4">
              <button
                className="bg-[#009e66] text-gray-100 text-lg p-3 rounded-full w-full focus:outline-none focus:shadow-outline hover:bg-[#117351] hover:scale-95 transition-all duration-300 ease-linear"
                type="submit"
                value="Send"
              >
                <span>
                  <SendIcon sx={{ marginLeft: "3px", marginRight: "6px" }} />
                  Send
                </span>
              </button>
            </div>
          </form>
        </div>
        <div className="md:px-12 lg:w-2/4 lg:pl-5 lg:pr-10 rounded-2xl shadow-2xl max-md:mt-8">
          <h1 className="font-bold text-2xl pb-5">Contact Info</h1>
          <p className="text-[#9f9f9f]">
            Always available for work if the right project
            <br /> comes along, Feel free to contact me!
          </p>
          <ul className="mt-3">
            <li>
              <div className="flex pl-2">
                <span className="pt-2 pr-8">
                  <HubIcon sx={{ color: "#009e66", fontSize: "35px" }} />
                </span>
                <div className="border-l pl-8 pt-2">
                  <h6>Name</h6>
                  <span className="text-[#9f9f9f]">Imam Hosen</span>
                </div>
              </div>
            </li>
            <li>
              <div className="flex pl-2">
                <span className="pt-4 pr-8">
                  <MapIcon sx={{ color: "#009e66", fontSize: "35px" }} />
                </span>
                <div className="border-l pl-8 pt-4">
                  <h6>Location</h6>
                  <span className="text-[#9f9f9f]">Barishal, Bangladesh</span>
                </div>
              </div>
            </li>
            <li>
              <div className="flex pl-2">
                <span className="pt-4 pr-8">
                  <CallIcon sx={{ color: "#009e66", fontSize: "35px" }} />
                </span>
                <div className="border-l pl-8 pt-4">
                  <h6>Call Me</h6>
                  <span className="text-[#9f9f9f]">
                    <a href="tel:8801799532172">+880 1733-570761</a>
                  </span>
                </div>
              </div>
            </li>
            <li>
              <div className="flex pl-2">
                <span className="pt-4 pr-8">
                  <SendIcon sx={{ color: "#009e66", fontSize: "35px" }} />
                </span>
                <div className="border-l pl-8 pt-4 max-sm:break-all">
                  <h6>Email Me</h6>
                  <span className="text-[#9f9f9f]">
                    <a href="mailto:mdimam.cse9.bu@gmail.com">
                      mdimam.cse9.bu@gmail.com
                    </a>
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Contact;
